module.exports = __webpack_public_path__ + "static/media/success.05cfdaf3.svg";